import SubCollectionEntityService from '@/services/SubCollectionEntiyService'
import { Message, messageConverter } from '@/models/message'
import { query, orderBy, limit, getDocs, where } from 'firebase/firestore'
import ProjectService from '@/services/ProjectService'
import { Project } from '@/models/project'

export default class MessageService extends SubCollectionEntityService<Message> {
  constructor (parentDocument: string) {
    super({ parentDocument, subCollectionName: 'messages', converter: messageConverter })
  }

  async getByProject(projectId: string) { 
    return await this.find_by('projectId', '==', projectId)
  }

  
  async getRecentMessages(options: { group?: boolean, daysAgo?: number, limit?: number } = { group: false, daysAgo: 7, limit: 25 }): Promise<Message[] | { [key: string]: Message[] }> {
    const daysAgoFilter = new Date()
    daysAgoFilter.setDate(daysAgoFilter.getDate() - options.daysAgo)

    const collectionRef = await this.getCollectionGroup()
    const queryRef = query(collectionRef,
      where('created', '>=', daysAgoFilter.toISOString()),
      orderBy('created', 'desc'),
      orderBy('projectId', 'asc'),
      limit(options.limit)
    ).withConverter(messageConverter)
    const querySnapshot = await getDocs(queryRef)
    const messages = querySnapshot.docs.map(doc => doc.data() as Message)


    const projectsMap = await this.getProjectsMap(messages)

    messages.forEach(message => {
      message.project = projectsMap[message.projectId]
    })
    if (options.group) return this.groupByProject(messages)
    
    return messages
  }

  private groupByProject(messages: Message[]) {
    return messages.reduce((oldArray: { [key: string]: Message[] }, message) => {
      if (!oldArray[message.projectId]) {
        oldArray[message.projectId] = []
      }

      oldArray[message.projectId].push(message)
      return oldArray
    }, {})
  }

  private async getProjectsMap(messages: Message[]) { 
    const projectService = new ProjectService()
    const uniqueProjectIds = new Set(messages.map(message => message.projectId))
    const projectPromises = Array.from(uniqueProjectIds).map(projectId => 
      projectService.find(projectId).then(project => ({ projectId, project }))
    )

    const projects = await Promise.all(projectPromises)
    const projectMap = projects.reduce((map, { projectId, project }) => {
      map[projectId] = project
      return map
    }, {} as { [key: string]: Project })

    return projectMap
  }
}

